export const GROUP_ENTITY_TARGET = {
  extra: 'checklists',
  questionModel: 'questionFormModels',
};

export const DEFAULT_TAB = 'general';
